import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/front/4_gothic-7/4_gothic-7"
 * Contains 6 texture(s)
 */
export class CardsFront4Gothic7Atlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/front/4_gothic-7/4_gothic-7';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '3-diamonds.png',
        '3-clubs.png',
        '2-spades.png',
        '2-hearts.png',
        '2-diamonds.png',
        '2-clubs.png'
    ] as const;
}
